import { InjectionToken } from '@angular/core';
import { IEnvironment } from './interfaces/environment.interface';

export const FACCIOBENE_ENVIRONMENT = new InjectionToken<IEnvironment>('FACCIOBENE_ENVIRONMENT');
